var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortoSeguroSmooth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 301,
    viewBox: "0 0 283 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M313.105 181.815C299.949 165.538 268.375 161.864 251.535 161.864C180.496 161.864 112.086 174.989 49.4651 199.141C49.9914 180.765 49.4651 161.864 47.3607 144.012C95.2467 130.361 179.443 118.809 234.697 123.536C286.793 128.261 306.263 157.138 313.105 181.815ZM289.95 134.561C275.743 120.91 264.691 111.46 220.489 105.158C176.812 98.8577 84.1963 108.309 43.1509 118.809C39.9927 102.533 36.3093 86.7817 31.0478 71.0302C58.9375 66.3052 87.8799 63.6803 117.349 63.6803C145.765 63.6803 174.181 66.3052 201.545 71.0302C259.955 80.4813 278.373 112.509 289.95 134.561ZM0 0.149598C148.922 -3.5259 232.592 61.5802 249.431 79.4318C234.697 67.3558 206.806 56.8541 182.6 52.6538C153.131 46.8782 122.611 44.2533 91.0369 44.2533C67.8835 44.2533 45.2553 45.8287 23.1546 48.9794C17.892 33.7527 7.36691 13.801 0 0.149598ZM289.95 275.797C314.159 226.444 308.368 217.518 261.008 223.293C187.863 232.22 95.7731 263.721 25.7852 301C38.4147 276.322 44.7289 251.645 47.3607 229.594C114.717 200.192 188.915 183.39 266.27 181.815C347.84 180.24 317.313 242.195 289.95 275.797Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 225,
    y2: 229.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortoSeguroSmooth);
export default __webpack_public_path__ + "static/media/porto-seguro-smooth.7682e71090fca834601e37b41a64d3e0.svg";
export { ForwardRef as ReactComponent };